import React, { useEffect, useState } from 'react';
import {
    Routes,
    Route,
    useLocation
} from "react-router-dom";

import SubReferenceUnitRate from './SubReferenceUnitRate.js';
import SubReferenceFT from './SubReferenceFT.js';
import SubReferenceHoliday from './SubReferenceHoliday.js';
import SubReferenceYear from './SubReferenceYear.js';
import SubReferenceNonePurchase from './SubReferenceNonePurchase.js';

import Minibar from '../../../components/navbar/Minibar.js';

function MainReference(props) {
    const location = useLocation();
    const [submenu_root, setSubmenu_root] = useState('Monthly Reference');

    useEffect(() => {
        if (location.pathname.search("/referenceyear") > -1) {
            setSubmenu_root('Yearly Reference')
        }
        if (location.pathname.search("/referencepurchase") > -1) {
            setSubmenu_root('None Purchase')
        }
        if (location.pathname.search("/referenceunitrate") > -1) {
            setSubmenu_root('Unit Rate')
        }
        if (location.pathname.search("/referenceft") > -1) {
            setSubmenu_root('FT Charge')
        }
        if (location.pathname.search("/referenceholiday") > -1) {
            setSubmenu_root('Holiday Calendar')
        }
    }, [location]);

    return (
        <section id="content" className="content">
            <Minibar
                main_root={"Reference"}
                submenu_root={submenu_root}
                systemtime={props.data_systemdatetime}
            />
            <div className="content__boxed d-md-flex h-100">
                <div className="content__wrap order-2 flex-fill min-w-0 hi-100 border-left">
                    <Routes>
                        <Route path="/referenceunitrate" element={<SubReferenceUnitRate
                            permitdata={props.permitdata}
                            callback_backcenter={() => { props.callback_backcenter() }}
                        ></SubReferenceUnitRate>} />
                        <Route path="/referenceft" element={<SubReferenceFT
                            permitdata={props.permitdata}
                            callback_backcenter={() => { props.callback_backcenter() }}
                        ></SubReferenceFT>} />
                        <Route path="/referenceholiday" element={<SubReferenceHoliday
                            permitdata={props.permitdata}
                            callback_backcenter={() => { props.callback_backcenter() }}
                        ></SubReferenceHoliday>} />
                        <Route path="/referenceyear" element={<SubReferenceYear
                            permitdata={props.permitdata}
                            callback_backcenter={() => { props.callback_backcenter() }}
                        ></SubReferenceYear>} />
                        <Route path="/referencepurchase" element={<SubReferenceNonePurchase
                            permitdata={props.permitdata}
                            callback_backcenter={() => { props.callback_backcenter() }}
                        ></SubReferenceNonePurchase>} />
                    </Routes>
                </div>
            </div>
        </section>

    )
}
export default MainReference